<template>
    <div class="text-center">
        <button
            class="btn btn-sm btn-default"
            @click="createGhostUser"
            :disabled="loading"
            type="button"
        >
            <i class="fa fa-spinner fa-spin" v-if="loading"></i> Continue As Guest
        </button>
    </div>
</template>

<script>
import createGhost from "./mixins/createGhost";

export default {
    name: 'GuestLogin',

    props: {
        email: {
            required: true,
            type: String,
        },
        redirect: {
            default: '',
            required: false,
            type: String,
        },
        urlPrefix: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    methods: {
        createGhostUser() {
            createGhost(this.email, this);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/GuestLogin.vue